export default "__VITE_ASSET__gR7qTuNQ__"